import { NavList } from "@/utils/constants";
import React from "react";
import NavListItem from "../NavListItem";

const NavbarMobileList = ({ toggleSidebar }: { toggleSidebar: () => void }) => {
  return (
    <div className="flex flex-col gap-5 h-[75%] justify-center items-center px-1">
      {NavList.map((item) => (
        <NavListItem onClick={toggleSidebar} key={item.id} {...item} />
      ))}
    </div>
  );
};

export default NavbarMobileList;
